module.exports = __webpack_public_path__ + "img/chinesecompany110.cc4752f3.png";